<template>
  <div>
    <!-- Pembangunan Menu -->
    <div
      class="pembangunan-menu"
      :class="{ open: isPembangunanMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>PEMBANGUNAN</span>
          </li> 
        -->
        <li>
          <RouterLink to="/pembangunan">
            Projek BP.1
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/pembangunan/bajet-mengurus">
            Bajet Mengurus
          </RouterLink>
        </li>
      </ul>
    </div>
    <div
      v-if="isPembangunanMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isPembangunanMenuOpen"
      class="pembangunan-toggle-button"
      @click="togglePembangunanMenu"
    >
      <span class="vertical-text">PEMBANGUNAN</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isPembangunanMenuOpen = ref(false)

const togglePembangunanMenu = () => {
  isPembangunanMenuOpen.value = !isPembangunanMenuOpen.value
  if (isPembangunanMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isPembangunanMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-pembangunan-menu', () => {
  isPembangunanMenuOpen.value = false
})
</script>

<style scoped>
/* Pembangunan Menu */
.pembangunan-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.pembangunan-menu.open {
  transform: translateX(0);
}



.pembangunan-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pembangunan-menu li {
  margin-bottom: 10px;
}

.pembangunan-menu a,
.pembangunan-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Pembangunan Toggle Button */
.pembangunan-toggle-button {
  position: fixed;
  top: 40%;
  right: 0;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 6px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.pembangunan-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
